import { appSelector } from "@/redux/selectors/app.selector";
import { useSelector } from "@/redux/store";

export const useShowInternalDebugInfo = () => {
  const isInternal = useSelector(appSelector.isInternal);
  if (import.meta.env.VITE_SHOW_AUDIT_TRAIL !== "true") return false;
  return import.meta.env.DEV || isInternal;
};
